"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  try {
    return JSON.parse(text);
  } catch (e) {
    return null;
  }
}